import { Link } from 'react-router-dom';
import React, { CSSProperties } from 'react';
import * as DateFns from 'date-fns';

//import Weather from "../Schedule/WeekSchedule/Week/DayHeader/Weather";
import Loader from '../Shared/Loader';
import { useRouter } from '../../helpers/customHooks';
import { useDataEventsState, useGameMeta } from "../../store/hooks";
import { ViewerRoutes } from './types';
import {
  GameMetaType,
  GameTeamMetaType,
  HomeAwayTeam,
} from "../../store/types";

export default () => {

  const { dataEvent: data } = useDataEventsState();
  const gameMeta: GameMetaType = useGameMeta();
  const { params, location } = useRouter<ViewerRoutes>();
  const { id, teamId, tab } = params;

  if (!data || !data.meta || !gameMeta) {
    return (<Loader style={{ height: '100%' }} />);
  }

  if (data.meta.gameId === gameMeta.gameId) {
    const overrideTeamStats = (team: HomeAwayTeam, fallback: GameTeamMetaType) => {
      team.nick = team.nick ?? fallback.nick;
      team.totalWins = team.totalWins ?? fallback.totalWins;
      team.totalLoss = team.totalLoss ?? fallback.totalLoss;
      team.totalTies = team.totalTies ?? fallback.totalTies;
      team.pointTotal = team.pointTotal ?? fallback.pointTotal;
    };

    overrideTeamStats(data.meta.homeTeam, gameMeta.homeTeam);
    overrideTeamStats(data.meta.visitorTeam, gameMeta.visitorTeam);
  }

  const homeTeam = data.meta.homeTeam.data;
  const awayTeam = data.meta.visitorTeam.data;
  const styleTeamName: CSSProperties = {
    paddingTop: '4px',
    color: +teamId === +awayTeam.teamId ? 'inherit' : awayTeam.color.text,
    fontFamily: `'Roboto Condensed', sans-serif`,
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '0px',
    height: '18px'
  };
  const styleTeamData: CSSProperties = {
    paddingTop: '10px',
    fontSize: '11px',
    fontWeight: 'normal',
    marginBottom: '0',
    fontFamily: `"Roboto Condensed", sans-serif`
  };

  if (data.meta.homeTeam.teamId === '194' || data.meta.homeTeam.teamId === '19410') {
    return (<>
      <div className="header-p-01">
        {/* <div className="e-l">@</div> */}
        <Link
          to={{
            pathname: (location && location.state && location.state.toReturn) || '/games',
            search: (location && location.state && location.state.toReturnSearch) || ''
          }}
          className="left-arrow"
        >
          <img src="/assets/images/sprites/left.svg" alt="" height="15px" />
        </Link>
        <Link
          to={{
            pathname: `/view/game/${id}/${homeTeam.teamId}/${tab === 'report' ? 'report' : 'performance/expanded/page'}`,
            state: location.state
          }}
          style={tab === 'game_manage'? {pointerEvents: 'none'}:{}}
        >
          <div
            className="h-img-01" style={{
            backgroundColor: +teamId === +homeTeam.teamId ? homeTeam.color.text : '',
            color: +teamId === +homeTeam.teamId ? 'white' : 'inherit',
            display: 'flex',
            height: '48px',
            justifyContent: 'flex-start'
          }}
          >
            <div
              style={{
                right: '0',
                width: '145px',
                height: '48px',
                top: '0px',
                position: 'absolute',
                overflow: 'hidden'
              }}
            >
              <img
                src={`/assets/images/logos/${homeTeam.teamAbbrName}.svg`} alt="" style={{
                width: '150px',
                position: 'absolute',
                right: '0',
                bottom: '-50px'
              }}
              />
            </div>
            <div>
              <label
                className="title-l-03" style={{
                padding: '0 20px',
                color: +teamId === +homeTeam.teamId ? 'inherit' : homeTeam.color.text,
                fontWeight: data.meta.visitorTeam && (data.meta.visitorTeam.pointTotal < data.meta.homeTeam.pointTotal) ? 'bold' : 'normal',
                fontFamily: `"Roboto", sans-serif`
              }}
              >{data.meta.homeTeam.pointTotal}</label>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <label
                style={{
                  ...styleTeamName,
                  color: +teamId === +homeTeam.teamId ? 'inherit' : homeTeam.color.text
                }}
              >{data.meta.homeTeam.nick || homeTeam.teamAbbrName}</label>
            </div>
          </div>
        </Link>
        <div className="p-l-t">
          <div className="rl-t">
            {DateFns.format(data.meta.startTime, 'MMMM d, yyyy, h:mmaaaaa') + `m `}{data.meta.siteFullName}
            {/* {weather ? <Weather weather={weather} modal withTooltip/> : null} */}
          </div>
        </div>
      </div>
    </>);
  }
  return (
    <>
      <div className="header-p-01">
        <div className="e-l">@</div>
        <Link
          to={{
            pathname: (location && location.state && location.state.toReturn) || '/games',
            search: (location && location.state && location.state.toReturnSearch) || ''
          }}
          className="left-arrow"
        >
          <img src="/assets/images/sprites/left.svg" alt="" height="15px" />
        </Link>
        <Link
          to={{
            pathname: `/view/game/${id}/${awayTeam.teamId}/${tab === 'report' ? 'report' : tab === 'ball'? 'ball/flights/page' : 'performance/expanded/page'}`,
            state: location.state,
            search: tab === 'ball'? '?view=byPlayer' : ''
          }}
          style={tab === 'game_manage'? {pointerEvents: 'none'}:{}}
        >
          <div
            className="h-img"
            style={{
              backgroundColor: +teamId === +awayTeam.teamId ? awayTeam.color.text : 'transparent',
              color: +teamId === +awayTeam.teamId ? 'white' : 'inherit',
              display: 'flex',
              height: '48px',
              justifyContent: 'flex-end'
            }}
          >
            <div
              style={{
                left: '0',
                width: '145px',
                height: '48px',
                top: '0px',
                position: 'absolute',
                overflow: 'hidden'
              }}
            >
              <img
                src={`/assets/images/logos/${awayTeam.teamAbbrName}.svg`} alt=""
                style={{
                  width: awayTeam.teamAbbrName === 'WAS' ? '130px' : '150px',
                  position: 'absolute',
                  left: '0',
                  bottom: awayTeam.teamAbbrName === 'WAS' ? '-20px' : '-50px'
                }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <label
                style={styleTeamName}
              >{data.meta.visitorTeam ? data.meta.visitorTeam.nick || awayTeam.teamNick : ''}</label>
              <label style={styleTeamData}>
                <b>{data.meta.visitorTeam ? !isNaN(data.meta.visitorTeam.totalWins) ? data.meta.visitorTeam.totalWins : '_' : ' '}
                  -{data.meta.visitorTeam ? !isNaN(data.meta.visitorTeam.totalLoss) ? data.meta.visitorTeam.totalLoss : '_' : ' '}
                  -{data.meta.visitorTeam ? !isNaN(data.meta.visitorTeam.totalTies) ? data.meta.visitorTeam.totalTies : '_' : ' '}</b>
                <span>•</span>{data.meta.visitorTeam ? data.meta.visitorTeam.data.division || awayTeam.teamNick : ''}
              </label>
            </div>
            <div>
              <label
                className="title-l-03"
                style={{
                  padding: '0 20px',
                  color: +teamId === +awayTeam.teamId ? 'inherit' : awayTeam.color.text,
                  fontWeight: data.meta.visitorTeam && data.meta.visitorTeam.pointTotal > data.meta.homeTeam.pointTotal ? 'bold' : 'normal', // Only for the winner
                  fontFamily: `"Roboto", sans-serif`
                }}
              >
                {data.meta.visitorTeam ? data.meta.visitorTeam.pointTotal : ''}
              </label>
            </div>
          </div>
        </Link>
        <Link
          to={{
            pathname: `/view/game/${id}/${homeTeam.teamId}/${tab === 'report' ? 'report' : tab === 'ball'? 'ball/flights/page': 'performance/expanded/page'}`,
            state: location.state,
            search: tab === 'ball'? '?view=byPlayer' : ''
          }}
          style={tab === 'game_manage'? {pointerEvents: 'none'}:{}}
        >
          <div
            className="h-img-01"
            style={{
              backgroundColor: +teamId === +homeTeam.teamId ? homeTeam.color.text : '',
              color: +teamId === +homeTeam.teamId ? 'white' : 'inherit',
              display: 'flex',
              height: '48px',
              justifyContent: 'flex-start'
            }}
          >
            <div
              style={{
                right: '0',
                width: '145px',
                height: '48px',
                top: '0px',
                position: 'absolute',
                overflow: 'hidden'
              }}
            >
              <img
                src={`/assets/images/logos/${homeTeam.teamAbbrName}.svg`} alt="" style={{
                width: homeTeam.teamAbbrName === 'WAS' ? '130px' : '150px',
                position: 'absolute',
                right: '0',
                bottom: homeTeam.teamAbbrName === 'WAS' ? '-20px' : '-50px'
              }}
              />
            </div>
            <div>
              <label
                className="title-l-03"
                style={{
                  padding: '0 20px',
                  color: +teamId === +homeTeam.teamId ? 'inherit' : homeTeam.color.text,
                  fontWeight: data.meta.visitorTeam && (data.meta.visitorTeam.pointTotal < data.meta.homeTeam.pointTotal) ? 'bold' : 'normal',
                  fontFamily: `"Roboto", sans-serif`
                }}
              >
                {data.meta.homeTeam.pointTotal}
              </label>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label
                style={{ ...styleTeamName, color: +teamId === +homeTeam.teamId ? 'inherit' : homeTeam.color.text }}
              >{data.meta.homeTeam.nick || homeTeam.teamNick}</label>
              <label style={styleTeamData}>
                <b>{!isNaN(data.meta.homeTeam.totalWins) ? data.meta.homeTeam.totalWins : '_'}
                  -{!isNaN(data.meta.homeTeam.totalLoss) ? data.meta.homeTeam.totalLoss : '_'}
                  -{!isNaN(data.meta.homeTeam.totalTies) ? data.meta.homeTeam.totalTies : '_'}</b>
                <span>•</span>{data.meta.homeTeam.data.division || homeTeam.teamNick}
              </label>
            </div>
          </div>
        </Link>
        <div className="p-l-t">
          <div className="rl-t">
            {DateFns.format(data.meta.startTime, 'MMMM d, yyyy, h:mmaaaaa') + `m `}{data.meta.siteFullName}
            {/* {weather ? <Weather weather={weather} modal withTooltip/> : null} */}
          </div>
        </div>
      </div>
    </>
  );
};
